import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { AccessibilityService } from './service/accessibility.service';
import { AccessibilitySettings } from './model/accessibility-settings';
import { Router, NavigationEnd } from '@angular/router';
import { UserIdleService } from 'angular-user-idle';
import { AuthService } from './service/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private userIdle: UserIdleService,
    public authService: AuthService,
    private _accessibilityService: AccessibilityService,
    @Inject(DOCUMENT) private _document: any,
    private router: Router
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd && event.url == '/landing') {
        this._idleListener();
      }
    })
  }

  ngOnInit() {
    this._updateAccessibility(this._accessibilityService.current);

    this._accessibilityService.changes.subscribe(next => {
      if (next) {
        this._updateAccessibility(next);
      }
    });
  }

  private _idleListener() {
    this.userIdle.startWatching();

    this.userIdle.onTimeout().first().subscribe(() => {
      console.log("Timeout Fired")
      this.authService._sessionTimeout = true;
      this.authService.logout().subscribe();
      this.authService.goToLoginPage();
    });

    this.userIdle.onTimerStart().subscribe();
  }

  private _updateAccessibility(settings: AccessibilitySettings) {
    const docClasses: DOMTokenList = this._document.documentElement.classList;

    docClasses.remove('small-text');
    docClasses.remove('large-text');

    docClasses.remove('high-contrast');
    docClasses.remove('inverted-contrast');
    

    if (settings.textSize === 'small') {
      docClasses.add('small-text');
    } else if (settings.textSize === 'large') {
      docClasses.add('large-text');
    }

    if (settings.contrast === 'high') {
      docClasses.add('high-contrast');
    } else if (settings.contrast === 'inverted') {
      docClasses.add('inverted-contrast');
    }
   
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts